import React from 'react';
import { CommandMenu } from '@milanote/roma';
import { GridListItem } from 'react-aria-components';
import { Plus } from '@untitledui/icons';

import { CREATE_LABEL } from '../hooks/useLabelListSelection';
import { useTranslator } from '../../../../../../components/i18n/useTranslator';

type Props = {
    searchString: string;
};

const CreateLabelListItem: React.FC<Props> = ({ searchString }) => {
    const translate = useTranslator('popup', 'labels.menu');

    if (!searchString) return null;

    return (
        <GridListItem
            id={CREATE_LABEL}
            textValue={searchString}
            className="CreateLabelListItem w-full py-0.5 outline-hidden"
        >
            {(state) => (
                <CommandMenu.Base.ItemStructured
                    leading={Plus}
                    label={translate('createLabel', { searchString })}
                    isSelected={state.isSelected}
                    isDisabled={state.isDisabled}
                    isFocused={state.isFocused}
                    isFocusVisible={state.isFocusVisible}
                    isHovered={state.isHovered}
                    className="mx-0.5"
                    size="sm"
                />
            )}
        </GridListItem>
    );
};

export default CreateLabelListItem;
